import { Theme } from '@mui/material/styles'

export const useStyle = {
  container: {
    padding: (theme: Theme) => theme.spacing(2.4),
  },
}
